import { getMeta } from "app/utils/meta";
import { getLoaderTrans } from "app/.server/utils";
import Layout from "app/components/layout";
import {
  BenefitsSection,
  CreatingCollectionFeatures,
  SayHelloToCollectionsSection,
  UseCasesItemsSection,
  UseCasesSection,
  WhatIsItSection,
} from "app/sections/collections";

export const loader = async ({ request, params }) => {
  const trans = await getLoaderTrans({ request, params });

  return {
    meta: {
      title: `${trans("Say Hello to Collections")} | ${trans("A new and powerful marketing tool in your hand that’s 90% more effective than emails.")}`,
    },
  };
};

export const meta = ({ loaderData: data }) => {
  return getMeta({
    title: data.meta.title,
  });
};

const Collections = () => {
  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <SayHelloToCollectionsSection />
      <WhatIsItSection />
      <UseCasesSection />
      <UseCasesItemsSection />
      <CreatingCollectionFeatures />
      <BenefitsSection />
    </Layout>
  );
};

export default Collections;
